export const deHero = {
  badge: 'Enterprise-Bestellplattform',
  title_part1: 'Bringen Sie Ihre',
  title_part2: ' Online-Bestellungen unter Kontrolle',
  subtitle:
    'Lewouhmart vereint Produktkatalog, Lagerbestand, Zahlungen und Lieferungen in einer sicheren, international skalierbaren Plattform.',
  cta_primary: 'Loslegen',
  cta_secondary: 'Live-Demo',
  feature_iam_title: 'Identität & Sicherheit',
  feature_iam_body:
    'Rollenbasierter Zugriff, MFA für Mitarbeiter und Transaktionssicherheit von Anfang an.',
  feature_global_title: 'Global bereit',
  feature_global_body:
    'Mehrsprachigkeit und mehrere Währungen ab dem ersten Tag.',
  feature_stock_title: 'Zuverlässiger Bestand',
  feature_stock_body:
    'Bestandsverwaltung sicher unter hoher Last mit präziser Gewinnberechnung.',
  carousel_section_label: 'Wichtige Plattform-Highlights',
  carousel_iam_title: 'Sichere IAM für Ihr gesamtes Team',
  carousel_iam_subtitle:
    'Mitarbeiter melden sich mit MFA und rollenbasiertem Zugriff an, während Kunden einen einfachen E-Mail‑/Passwort-Flow nutzen.',
  carousel_global_title: 'Von Anfang an global bereit',
  carousel_global_subtitle:
    'Bedienen Sie Kunden in mehreren Sprachen und Währungen, mit Präferenzen, die zwischen Geräten mitreisen.',
  carousel_stock_title: 'Zuverlässiger Bestand und Fulfillment',
  carousel_stock_subtitle:
    'Bestandskontrolle und Sendungsverfolgung sorgen für genaue und vorhersagbare Abläufe.',
} as const;

export const deAuth = {
  tab_sign_in: 'Anmelden',
  tab_register: 'Konto erstellen',
  sign_in_title: 'Bei Lewouhmart anmelden',
  sign_in_subtitle:
    'Melden Sie sich mit E-Mail und Passwort an, um auf Bestellungen und Kontoeinstellungen zuzugreifen.',
  sign_in_customer_hint:
    'Melden Sie sich mit der E-Mail-Adresse und dem Passwort Ihres Kundenkontos an.',
  register_title: 'Ihr Kundenkonto erstellen',
  register_subtitle:
    'Verwenden Sie Ihre E-Mail-Adresse und ein starkes Passwort. Wir bitten Sie, Ihre E-Mail bei der ersten Anmeldung zu bestätigen.',
  email_label: 'E-Mail-Adresse',
  password_label: 'Passwort',
  password_placeholder: 'Mindestens 8 Zeichen',
  sign_in_button: 'Weiter',
  register_button: 'Konto erstellen',
  register_invite_applied:
    'Sie registrieren sich mit Empfehlungscode {{code}}. Die Berechtigung wird geprüft, wenn Sie Ihre erste qualifizierende bezahlte Bestellung abschließen.',
  register_invite_code_label: 'Empfehlungscode (optional)',
  register_invite_code_placeholder: 'Einladungscode',
  register_invite_code_hint:
    'Leer lassen, wenn Sie keinen haben. Ein Code im Einladungslink (?ref=…) wird automatisch übernommen.',
  register_apply_referral_checkbox: 'Empfehlungscode verwenden',
  register_referral_required_when_checked:
    'Geben Sie einen Empfehlungscode ein oder deaktivieren Sie das Kontrollkästchen, um ohne Code fortzufahren.',
  mfa_title: 'Sicherheitscode eingeben',
  mfa_body_intro: 'Wir haben einen 6-stelligen Code gesendet an',
  mfa_body_outro: 'Geben Sie ihn ein, um die Anmeldung abzuschließen.',
  mfa_button: 'Prüfen und fortfahren',
  mfa_resend: 'Code erneut senden',
  mfa_resend_sending: 'Wird gesendet…',
  mfa_resend_wait: 'Code erneut senden in {{seconds}}s',
  mfa_resend_failed: 'Code konnte nicht erneut gesendet werden.',
  mfa_back_to_sign_in: 'Zurück zur Anmeldung',
  mfa_resend_policy:
    'Sie können den Code bis zu 3-mal pro Stunde erneut anfordern. Wenn keine E-Mail ankommt, prüfen Sie Spam oder die Server-E-Mail-Konfiguration (SES).',
  signed_in_title: 'Sie sind angemeldet',
  signed_in_body:
    'Ihre Sprach- und Währungseinstellungen sind mit Ihrem Profil synchronisiert. Zukünftige Sitzungen und andere Clients (z. B. eine mobile App) können sie wiederverwenden.',
  signed_in_label: 'Angemeldet als',
  signed_in_logout: 'Abmelden',
  register_success_prefix: 'Konto erstellt für',
  register_success_suffix:
    'Wir haben Ihnen eine Bestätigungs-E-Mail gesendet. Bitte bestätigen Sie diese in Ihrem Posteingang, bevor Sie sich anmelden.',
  register_success_banner_title: 'Posteingang prüfen — letzter Schritt',
  register_form_locked_note:
    'Dieses Formular bleibt gesperrt, bis Sie Ihre E-Mail bestätigt haben. Sie können diesen Tab schließen, nachdem Sie unsere Nachricht geöffnet haben.',
  verify_email_resent:
    'Ihre E-Mail-Adresse ist noch nicht bestätigt. Wir haben Ihnen soeben eine weitere Bestätigungs-E-Mail gesendet. Bitte bestätigen Sie diese, bevor Sie es erneut versuchen.',
  verify_email_heading: 'Bestätigen Sie Ihre E-Mail-Adresse',
  verify_email_loading: 'Ihre E-Mail wird geprüft, bitte warten…',
  verify_email_success:
    'Ihre E-Mail wurde erfolgreich bestätigt. Sie können sich jetzt anmelden.',
  verify_email_error:
    'Wir konnten Ihre E-Mail nicht bestätigen. Der Link ist möglicherweise abgelaufen oder wurde bereits verwendet.',
  verify_email_missing_token:
    'Der Bestätigungslink ist ungültig. Bitte verwenden Sie den Link aus Ihrer E-Mail oder fordern Sie einen neuen an.',
  verify_email_back_to_signin: 'Zur Anmeldung',
  forgot_link: 'Passwort vergessen?',
  forgot_title: 'Passwort zurücksetzen',
  forgot_subtitle:
    'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.',
  forgot_submit: 'Link zum Zurücksetzen senden',
  forgot_sending: 'Wird gesendet…',
  forgot_success:
    'Falls ein Konto existiert, wurde ein Link zum Zurücksetzen gesendet.',
  forgot_error: 'Zurücksetz-E-Mail konnte nicht gesendet werden.',
  reset_title: 'Neues Passwort wählen',
  reset_subtitle:
    'Legen Sie ein neues Passwort für Ihr Lewouhmart-Konto fest.',
  reset_password_label: 'Neues Passwort',
  reset_confirm_password_label: 'Neues Passwort bestätigen',
  reset_submit: 'Neues Passwort speichern',
  reset_saving: 'Wird gespeichert…',
  reset_mismatch: 'Die Passwörter stimmen nicht überein.',
  reset_invalid_link:
    'Dieser Zurücksetzlink ist ungültig. Bitte verwenden Sie den Link aus Ihrer E-Mail.',
  reset_success:
    'Ihr Passwort wurde aktualisiert. Sie können sich jetzt anmelden.',
  reset_error: 'Passwort konnte nicht zurückgesetzt werden.',
  reset_back_to_signin: 'Zur Anmeldung',
  account_deleted_notice:
    'Ihr Konto wurde gelöscht. Schade, dass Sie uns verlassen.',
  email_placeholder: 'sie@beispiel.de',
  security_block_title: 'Kontosicherheit',
  security_block_loading: 'Wird bestätigt…',
  security_block_success:
    'Ihr Teamkonto wurde gesperrt. Aktive Sitzungen wurden beendet. Wenden Sie sich an eine Administratorin oder einen Administrator, um den Zugang wiederherzustellen.',
  security_block_error_generic: 'Link ungültig, bereits verwendet oder abgelaufen.',
  security_block_missing_token: 'Kein Sicherheitstoken angegeben.',
  security_block_back_sign_in: 'Zur Anmeldung',
} as const;

export const deLayout = {
  app_name: 'Lewouhmart',
  app_tagline: 'Commerce- & Bestellmanagement',
  footer_right:
    'Entwickelt für Zuverlässigkeit, Parallelität und globales Wachstum.',
} as const;

export const deAccount = {
  title: 'Mein Konto',
  subtitle:
    'Profil, Anmeldesicherheit und Standard-Lieferadresse an einem Ort.',
  sign_in_required: 'Melden Sie sich an, um Ihr Konto anzuzeigen.',
  profile_section_title: 'Kontakt & Lieferung',
  profile_section_subtitle:
    'Wird auf Bestellungen, Rechnungen und Versandetiketten angezeigt.',
  field_full_name: 'Vollständiger Name',
  field_phone: 'Telefon',
  field_street: 'Straße und Hausnummer',
  field_city: 'Stadt',
  field_postal_code: 'Postleitzahl',
  field_country: 'Land',
  readonly_name_label: 'Name',
  readonly_phone_label: 'Telefon',
  readonly_address_label: 'Adresse',
  not_set: 'Nicht festgelegt',
  save_button: 'Änderungen speichern',
  cancel_button: 'Abbrechen',
  edit_button: 'Bearbeiten',
  status_label: 'Status',
  status_verified: 'Bestätigt',
  status_pending: 'Bestätigung ausstehend',
  email_label: 'Konten-E-Mail',
  load_error: 'Kontoinformationen konnten nicht geladen werden.',
  save_success: 'Profil erfolgreich aktualisiert.',
  save_error: 'Profil konnte nicht gespeichert werden.',
  security_section_title: 'Sicherheit',
  current_password_label: 'Aktuelles Passwort',
  new_password_label: 'Neues Passwort',
  confirm_password_label: 'Neues Passwort bestätigen',
  password_mismatch: 'Die Passwörter stimmen nicht überein.',
  password_save_button: 'Passwort aktualisieren',
  password_saving_label: 'Aktualisierung…',
  password_change_success: 'Passwort erfolgreich aktualisiert.',
  password_change_error: 'Passwort konnte nicht geändert werden.',
  password_open_button: 'Passwort ändern',
  delete_section_title: 'Konto schließen',
  delete_section_intro:
    'Mit der Löschung entfällt der Zugriff auf dieses Profil. Bestellunterlagen können aus rechtlichen oder betrieblichen Gründen bestehen bleiben, sind aber nicht mehr Ihrer Person zugeordnet.',
  delete_email_retention:
    'Zur Betrugs- und Empfehlungsprävention speichern wir eine normalisierte Form Ihrer E-Mail-Adresse dauerhaft. Registrieren Sie sich erneut mit derselben Adresse, erhalten Sie ein neues Profil ohne Verbindung zu früheren Bestellungen oder Empfehlungsaktivität.',
  delete_phrase_hint_before: 'Geben Sie exakt ein:',
  delete_password_label: 'Aktuelles Passwort (erforderlich)',
  delete_confirm_label: 'Geben Sie diese Phrase zur Bestätigung ein',
  delete_confirm_placeholder: 'I-want-to-delete-account',
  delete_confirm_mismatch:
    'Geben Sie exakt die Phrase I-want-to-delete-account ein.',
  delete_password_required: 'Bitte geben Sie Ihr aktuelles Passwort ein.',
  delete_submit: 'Mein Konto löschen',
  delete_submitting: 'Wird gelöscht…',
  delete_error: 'Konto konnte nicht gelöscht werden. Prüfen Sie Ihr Passwort.',
  delete_success_redirect: 'Ihr Konto wurde gelöscht.',
  retention_offer_percent:
    'Wenn Sie bleiben: {{percent}}% auf die Warenzwischensumme Ihrer nächsten Bestellung (einmalig, an der Kasse).',
  retention_accepted_with_percent:
    'Danke, dass Sie bleiben. Ihre nächste Bestellung enthält einmalig {{percent}}% Rabatt auf die Warenzwischensumme — sichtbar an der Kasse und auf der Quittung.',
  retention_banner_title: 'Bleib-Rabatt aktiviert',
  retention_banner_dismiss: 'Schließen',
  retention_cancel: 'Abbrechen',
  retention_email_cooldown_notice:
    'Diese E-Mail hat kürzlich das Bleib-Angebot oder den einmaligen Kontolöschungs-Rabatt genutzt. Das Angebot ist erst wieder ab {{date}} (UTC) verfügbar.',
  sidebar_overview: 'Konto',
  sidebar_orders: 'Bestellungen',
  sidebar_referrals: 'Empfehlungen',
  sidebar_security: 'Sicherheit',
  sidebar_notifications: 'Benachrichtigungen',
  orders_title: 'Meine Bestellungen',
  orders_subtitle: 'Verfolgen Sie den Status und die Historie Ihrer Bestellungen.',
  orders_search_placeholder: 'Bestellnr. oder Artikel suchen',
  orders_empty: 'Noch keine Bestellungen.',
  orders_empty_filtered: 'Keine Bestellungen entsprechen den Filtern.',
  order_id: 'Bestellung',
  payment_id: 'Zahlungs-ID',
  payment_id_none: '—',
  preorder_payments_heading: 'Vorbestellung – Kartenzahlungen',
  preorder_deposit_payment_label: 'Anzahlung – Zahlungs-ID',
  preorder_balance_payment_label: 'Restbetrag – Zahlungs-ID',
  preorder_balance_payments_label: 'IDs Restzahlung(en)',
  preorder_balance_payment_index: '{{n}}.',
  preorder_balance_payment_pending: 'Noch nicht belastet (fällig nach Freigabe)',
  items: 'Positionen',
  eta: 'Voraussichtliche Lieferung',
  eta_days: '{{days}} Tage',
  delivery_window_from: 'Von',
  delivery_window_until: 'Bis',
  order_history: 'Bestellverlauf',
  cancel_order: 'Bestellung stornieren',
  order_collapsed_hint:
    'Abgeschlossene Bestellung eingeklappt. Aufklappen für Details.',
  orders_pagination_info: 'Seite {{page}} von {{totalPages}}',
  orders_load_error: 'Bestellungen konnten nicht geladen werden.',
  orders_cancel_error: 'Bestellung konnte nicht storniert werden.',
  order_receipt_download: 'Quittung (PDF)',
  order_receipt_error: 'Quittung konnte nicht heruntergeladen werden.',
  order_event_update: 'Aktualisierung',
  order_event_change: '{{from}} → {{to}}',
  saving_label: 'Wird gespeichert…',
  order_status_PENDING: 'Ausstehend',
  order_status_PAID: 'Bezahlt',
  order_status_SHIPPED: 'Versendet',
  order_status_DELIVERED: 'Geliefert',
  order_status_CLOSED: 'Abgeschlossen',
  order_status_CANCELLED: 'Storniert',
  order_status_UNREACHABLE: 'Nicht erreichbar',
  order_status_DAMAGED: 'Beschädigt',
  order_status_INVESTIGATING: 'In Prüfung',
  order_status_FAULT_EMPLOYEE: 'Fehler (Mitarbeiter)',
  order_status_FAULT_CUSTOMER: 'Fehler (Kunde)',
  order_status_RESHIP_PENDING: 'Neuversand ausstehend',
  order_status_RESHIPPED: 'Neu versendet',
  referrals_copied: 'Kopiert!',
  referrals_status_pending: 'Warte auf qualifizierende Bestellung',
  referrals_status_qualified: 'Abgeschlossen',
  referrals_status_rejected: 'Nicht berechtigt',
  referrals_signup_only_note:
    'Empfehlungslinks und -codes werden bei der Kontoerstellung verwendet—nicht an der Kasse. Wenn Sie sich über den Link eines Freundes registriert haben, ist das bereits mit Ihrem Profil verknüpft; Sie geben es beim Bezahlen nicht erneut ein.',
  referrals_pending_hint:
    'Es ist keine manuelle Freigabe nötig. Sobald Ihre erste Bestellung bezahlt ist und den Mindestbetrag ({{min}} USD) erreicht, wird die Empfehlung automatisch abgeschlossen. Sie geben bei der Bezahlung keinen Empfehlungscode ein.',
  referrals_qualified_hint:
    'Ihre Empfehlung ist abgeschlossen: Registrierung mit Freundschaftslink und erste qualifizierende Bestellung. Die angezeigten Beträge sind Programmziele—sie erscheinen nicht als zusätzliches Feld an der Kasse. Wie Prämien ausgezahlt werden (Guthaben, Auszahlung usw.), legt der Shop fest; wenden Sie sich an den Support, wenn Sie einen sofortigen Rabatt erwartet haben.',
  referrals_rejected_hint:
    'Diese Empfehlung konnte nicht gewertet werden. Bei Fragen wenden Sie sich an den Support.',
  referrals_subtitle_ended:
    'Dieses Empfehlungsprogramm nimmt keine neuen Teilnehmer mehr auf. Ihre bisherige Aktivität sehen Sie unten.',
  referrals_program_ended_banner:
    'Das Empfehlungsprogramm nimmt keine neuen Teilnehmer mehr auf. Ihr Verlauf bleibt erhalten. Laufende Empfehlungen können abgeschlossen werden, sobald qualifizierende Bestellungen bezahlt sind.',
  referrals_program_ended_no_new_links:
    'Neue Einladungslinks sind deaktiviert. Dies war Ihr Code, solange das Programm aktiv war.',
  referrals_disabled: 'Das Empfehlungsprogramm ist derzeit nicht aktiv.',
} as const;

export const deHeader = {
  brand_name: 'Lewouhmart',
  brand_tagline: 'Commerce- & Bestellmanagement',
  nav_home: 'Start',
  nav_cart: 'Warenkorb',
  nav_admin_dashboard: 'Dashboard',
  nav_admin_employees: 'Mitarbeiter',
  nav_admin_customers: 'Kunden',
  nav_products: 'Produkte',
  nav_products_catalog: 'Katalog',
  nav_products_inventory: 'Bestand & Einkäufe',
  logged_in_as: 'Angemeldet als',
  account_button: 'Konto',
  logout_button: 'Abmelden',
} as const;

export const deFooter = {
  copyright: 'Lewouhmart. Alle Rechte vorbehalten.',
  footer_right:
    'Entwickelt für Zuverlässigkeit, Parallelität und globales Wachstum.',
  workspace_internal: 'Team-Bereich.',
  workspace_open_storefront: 'Kundenwebsite',
  customer_heading: 'Kunde',
  link_home: 'Start',
  link_products: 'Produkte',
  link_cart: 'Warenkorb',
  link_track_orders: 'Bestellungen verfolgen',
  link_feedback_complaints: 'Feedback & Beschwerden',
  link_about: 'Über uns',
  link_cookie_settings: 'Cookie-Einstellungen',
  ops_heading: 'Betrieb',
  link_employee_signin: 'Mitarbeiter-Anmeldung',
  ops_live_workflow: 'Live-Bestellablauf',
  ops_incidents: 'Vorfälle & Lösung',
  ops_analytics: 'Bestellanalysen nach Land',
  support_heading: 'Support & Rechtliches',
  terms: 'Nutzungsbedingungen',
  privacy: 'Datenschutz',
  storefront_tagline: 'Entwickelt für zuverlässige Bestellungen im großen Maßstab.',
  storefront_about:
    'Globale Plattform für Bestellungen, Lager und Sendungsverfolgung für moderne Commerce-Teams.',
} as const;

export const deAdmin = {
  sidebar_overview: 'Übersicht',
  sidebar_employees: 'Mitarbeiter',
  sidebar_customers: 'Kunden',
  sidebar_customer_archives: 'Gelöschte Konten (Archiv)',
  sidebar_products: 'Produkte',
  sidebar_categories: 'Kategorien',
  sidebar_inventory: 'Bestand',
  sidebar_hero: 'Startseiten-Bereich',
  sidebar_landing_promotion: 'Start-Aktion',
  sidebar_mail_routing: 'E-Mail-Absender',
  sidebar_group_users: 'Benutzer',
  sidebar_group_products: 'Produkte',
  sidebar_group_settings: 'Einstellungen',
  sidebar_group_site_settings: 'Website-Einstellungen',
  sidebar_group_system: 'Systemeinstellungen',
  sidebar_suppliers: 'Lieferanten',
  sidebar_roles: 'Rollen',
  suppliers_title: 'Lieferanten',
  suppliers_subtitle:
    'Verwalten Sie Ihre Lieferanten. Nur Mitarbeitende können Lieferanten erstellen und bearbeiten; Lieferanten melden sich nicht an.',
  suppliers_search: 'Suche nach Name, E-Mail oder Telefon',
  suppliers_active_only: 'Nur aktiv',
  suppliers_new: 'Neuer Lieferant',
  suppliers_hide_form: 'Formular ausblenden',
  suppliers_name: 'Name',
  suppliers_email: 'E-Mail',
  suppliers_phone: 'Telefon',
  suppliers_country: 'Land',
  suppliers_country_placeholder: 'Land auswählen',
  suppliers_city: 'Stadt',
  suppliers_address: 'Adresse',
  suppliers_notes: 'Notizen',
  suppliers_save: 'Lieferant speichern',
  suppliers_update: 'Lieferant aktualisieren',
  suppliers_loading: 'Lieferanten werden geladen…',
  suppliers_empty: 'Keine Lieferanten gefunden.',
  suppliers_col_name: 'Name',
  suppliers_col_email: 'E-Mail',
  suppliers_col_phone: 'Telefon',
  suppliers_col_country: 'Land',
  suppliers_col_city: 'Stadt',
  suppliers_col_status: 'Status',
  suppliers_status_active: 'Aktiv',
  suppliers_status_inactive: 'Inaktiv',
  suppliers_edit: 'Bearbeiten',
  suppliers_activate: 'Aktivieren',
  suppliers_deactivate: 'Deaktivieren',
  suppliers_load_error: 'Lieferanten konnten nicht geladen werden.',
  suppliers_save_error: 'Lieferant konnte nicht gespeichert werden.',
  suppliers_update_error: 'Lieferant konnte nicht aktualisiert werden.',
  categories_title: 'Kategorien',
  categories_subtitle: 'Produktkategorien für den Shop und die Startseite verwalten.',
  categories_count: 'Kategorien',
  categories_add: 'Kategorie hinzufügen',
  categories_name: 'Name',
  categories_slug: 'Slug (URL)',
  categories_slug_placeholder: 'z. B. gemuese',
  categories_description: 'Beschreibung',
  categories_sort_order: 'Sortierung',
  categories_list: 'Alle Kategorien',
  categories_loading: 'Laden…',
  categories_empty: 'Noch keine Kategorien.',
  categories_active: 'Aktiv',
  categories_update: 'Aktualisieren',
  categories_create: 'Erstellen',
  categories_confirm_delete: 'Diese Kategorie löschen?',
  categories_yes: 'Ja',
  categories_no: 'Nein',
  categories_load_error: 'Kategorien konnten nicht geladen werden.',
  categories_save_error: 'Kategorie konnte nicht gespeichert werden.',
  categories_delete_error: 'Kategorie konnte nicht gelöscht werden.',
  categories_duplicate_slug:
    'Eine Kategorie mit diesem URL-Slug existiert bereits. Ändern Sie den Slug oder den Namen.',
  categories_duplicate_generic:
    'Eine Kategorie mit diesem Namen oder URL-Slug existiert bereits. Ändern Sie die Werte und versuchen Sie es erneut.',
  categories_field_name_taken: 'Dieser Name wird bereits von einer anderen Kategorie verwendet.',
  categories_field_slug_taken: 'Dieser URL-Slug wird bereits von einer anderen Kategorie verwendet.',
  categories_unique_hint: 'Name und URL-Slug jeder Kategorie müssen eindeutig sein.',
  hero_title: 'Startseiten-Carousel',
  hero_subtitle: 'Vollbild-Dias auf der öffentlichen Startseite verwalten.',
  hero_form_edit: 'Dia bearbeiten',
  hero_form_new: 'Neues Dia',
  hero_label_image: 'Bild',
  hero_label_headline: 'Überschrift',
  hero_label_subheadline: 'Untertitel',
  hero_label_button_label: 'Button-Text',
  hero_label_button_link: 'Button-Link',
  hero_label_sort_order: 'Sortierung',
  hero_label_active: 'Aktiv',
  hero_btn_clear: 'Zurücksetzen',
  hero_btn_save: 'Speichern',
  hero_btn_add_slide: 'Dia hinzufügen',
  hero_existing_slides: 'Vorhandene Dias',
  hero_loading: 'Laden…',
  hero_empty: 'Noch keine Dias. Erstellen Sie links das erste.',
  hero_order: 'Reihe',
  hero_button: 'Button',
  hero_link: 'Link',
  hero_btn_edit: 'Bearbeiten',
  hero_active: 'Aktiv',
  hero_inactive: 'Inaktiv',
  hero_btn_delete: 'Löschen',
  hero_confirm_delete: 'Dieses Dia löschen?',
  hero_error_headline: 'Überschrift ist erforderlich',
  hero_error_upload: 'Bitte laden Sie ein Bild hoch',
  hero_shop_now_default: 'Jetzt einkaufen',
  dashboard_title: 'Admin-Bereich',
  dashboard_subtitle:
    'Überwachen Sie Ihr Team und Ihre Kundenbasis an einem Ort.',
  dashboard_card_employees_title: 'Mitarbeiter',
  dashboard_card_employees_body:
    'Übersicht aller Mitarbeiterkonten mit erzwungenem MFA.',
  dashboard_card_customers_title: 'Kunden',
  dashboard_card_customers_body:
    'Registrierte Kunden mit bestätigten E-Mail-Adressen.',
  dashboard_card_security_title: 'Sicherheit',
  dashboard_card_security_body:
    'Mitarbeiter authentifizieren sich immer mit einem zusätzlichen E-Mail-Code.',

  employees_title: 'Mitarbeiter',
  employees_subtitle:
    'Laden Sie Mitarbeiter zu Lewouhmart ein und verwalten Sie deren Basisdaten.',
  employees_invite_title: 'Neuen Mitarbeiter einladen',
  employees_invite_email_label: 'Geschäftliche E-Mail',
  employees_invite_name_label: 'Vollständiger Name',
  employees_invite_role_label: 'Berufsbezeichnung',
  employees_invite_phone_label: 'Telefon',
  employees_invite_type_label: 'Kontotyp',
  employees_invite_type_employee: 'Mitarbeiter',
  employees_invite_type_admin: 'Administrator',
  employees_invite_type_shipping_agent: 'Versandmitarbeiter',
  roles_select_placeholder: 'Rolle auswählen',
  employees_invite_submit: 'Einladung senden',
  employees_invite_sending: 'Wird gesendet…',
  employees_invite_success: 'Einladungs-E-Mail an Mitarbeiter gesendet.',
  employees_invite_error: 'Einladung konnte nicht gesendet werden.',
  employees_table_title: 'Teammitglieder',
  employees_table_loading: 'Mitarbeiter werden geladen…',
  employees_table_empty:
    'Noch keine Mitarbeiter vorhanden. Senden Sie eine Einladung, um zu beginnen.',
  employees_table_col_name: 'Name',
  employees_table_col_email: 'E-Mail',
  employees_table_col_role: 'Rolle',
  employees_table_col_status: 'Status',
  employees_blocked_intrusion: 'Gesperrt (Selbstservice, Einbruch)',
  employees_table_status_active: 'AKTIV',

  customers_title: 'Kunden',
  customers_subtitle:
    'Verzeichnis filtern, nach Umsatz oder Bestellanzahl sortieren und einen Kunden für Profil und Bestellungen öffnen.',
  customers_loading: 'Kunden werden geladen…',
  customers_empty: 'Keine Kunden entsprechen den Filtern.',
  customers_error: 'Kunden konnten nicht geladen werden.',
  customers_table_col_name: 'Name',
  customers_table_col_email: 'E-Mail',
  customers_table_col_phone: 'Telefon',
  customers_table_col_status: 'Status',
  customers_filter_section: 'Filter',
  customers_filter_show: 'Filter anzeigen',
  customers_filter_hide: 'Filter ausblenden',
  customers_filter_collapsed_hint:
    'Filter sind ausgeblendet für eine klarere Tabellenansicht. Aktive Kriterien gelten weiter.',
  customers_filter_section_hint:
    'Land und Stadt schlagen Werte aus Kundenprofilen vor. Wählen Sie zuerst das Land, um Städte einzugrenzen.',
  customers_suggest_loading: 'Vorschläge werden geladen…',
  customers_suggest_error:
    'Vorschläge konnten nicht geladen werden. Verbindung prüfen oder erneut versuchen.',
  customers_suggest_no_countries: 'Noch keine Länder in Kundenprofilen gespeichert.',
  customers_suggest_no_cities: 'Noch keine Städte in Kundenprofilen gespeichert.',
  customers_suggest_no_match: 'Kein passender Wert in Ihren Kundendaten.',
  customers_filter_search: 'Suche (Name, E-Mail, Telefon)',
  customers_filter_search_ph: 'Zum Filtern tippen…',
  customers_filter_phone: 'Telefon',
  customers_filter_phone_ph: 'Ziffern oder +Vorwahl',
  customers_filter_country: 'Land',
  customers_filter_country_ph: 'z. B. Deutschland',
  customers_filter_city: 'Stadt',
  customers_filter_city_ph: 'z. B. Berlin',
  customers_filter_registered_from: 'Registriert ab',
  customers_filter_registered_to: 'Registriert bis',
  customers_filter_apply: 'Filter anwenden',
  customers_filter_reset: 'Zurücksetzen',
  customers_sort_label: 'Sortieren nach',
  customers_sort_created_desc: 'Neueste Registrierung',
  customers_sort_created_asc: 'Älteste Registrierung',
  customers_sort_spend_desc: 'Höchster Gesamtumsatz (USD)',
  customers_sort_spend_asc: 'Niedrigster Gesamtumsatz (USD)',
  customers_sort_orders_desc: 'Meiste Bestellungen',
  customers_sort_orders_asc: 'Wenigste Bestellungen',
  customers_col_orders: 'Bestellungen',
  customers_col_spend: 'Umsatz (USD)',
  customers_col_city: 'Stadt',
  customers_col_country: 'Land',
  customers_col_drive_time: 'Fahrzeit',
  customers_col_actions: 'Aktionen',
  customers_open_detail: 'Ansehen',
  customer_archives_title: 'Gelöschte Konten — Archiv',
  customer_archives_subtitle:
    'Unveränderliche Snapshots bei Kontolöschung. Bestellungen bleiben (ohne Kundenverknüpfung); Archiv öffnen für JSON und Links zu Live-Bestellungen.',
  customer_archives_search_label: 'Suche',
  customer_archives_search_ph: 'Normalisierte E-Mail oder frühere Benutzer-ID',
  customer_archives_search_submit: 'Suchen',
  customer_archives_empty: 'Noch keine Lösch-Archive.',
  customer_archives_error: 'Archive konnten nicht geladen werden.',
  customer_archives_col_deleted: 'Gelöscht am',
  customer_archives_col_name: 'Name (Snapshot)',
  customer_archives_col_email: 'E-Mail (normalisiert)',
  customer_archives_col_former_id: 'Frühere Benutzer-ID',
  customer_archives_col_orders: 'Bestellungen (Snapshot)',
  customer_archives_col_actions: 'Aktionen',
  customer_archives_open: 'Öffnen',
  customer_archives_page_range: '{{from}}–{{to}} von {{total}}',
  customer_archive_detail_back: 'Archivliste',
  customer_archive_detail_title: 'Lösch-Archiv',
  customer_archive_detail_subtitle:
    'Compliance-Snapshot zum Löschzeitpunkt. Live-Bestellungen bei ORDER:READ.',
  customer_archive_detail_summary: 'Übersicht',
  customer_archive_detail_trigger: 'Auslöser',
  customer_archive_detail_orders_live: 'Bestellungen (live)',
  customer_archive_detail_order_id: 'Bestell-ID',
  customer_archive_detail_batch: 'Lieferbatch',
  customer_archive_detail_open_order: 'In Bestellungen öffnen',
  customer_archive_detail_snapshot_json: 'Vollständiger Snapshot (JSON)',
  customer_archive_detail_snapshot_hint:
    'Profil, Bestell-IDs, Empfehlung, Exit-Umfrage, Vorschau-Zähler.',
  customer_archive_detail_not_found: 'Archiv nicht gefunden.',
  customer_archive_detail_error: 'Archiv konnte nicht geladen werden.',
  customers_total_count: '{{count}} Kunden',
  customers_page_range: '{{from}}–{{to}} von {{total}}',
  customers_page_of: 'Seite {{page}} / {{pages}}',
  customers_page_prev: 'Zurück',
  customers_page_next: 'Weiter',
  customers_rows_per_page: 'Zeilen pro Seite',
  customers_page_showing: 'Seite {{page}} / {{pages}}',
  customers_detail_back: 'Zurück zur Kundenliste',
  customers_detail_loading: 'Kunde wird geladen…',
  customers_detail_error: 'Kunde konnte nicht geladen werden.',
  customers_detail_not_found: 'Kunde nicht gefunden.',
  customers_detail_total_spend: 'Gesamtumsatz',
  customers_detail_orders: 'Bestellungen',
  customers_detail_profile: 'Profil',
  customers_detail_id: 'Kunden-ID',
  customers_detail_address: 'Adresse',
  customers_detail_lat_lng: 'Breite / Länge',
  customers_detail_drive_time: 'Fahrzeit (Lager → Adresse)',
  customers_detail_drive_status: 'Routenstatus',
  customers_detail_created: 'Erstellt',
  customers_detail_last_login: 'Letzte Anmeldung',
  customers_detail_preferences: 'Einstellungen',
  customers_detail_order_summary: 'Bestellübersicht',
  customers_detail_last_order: 'Letzte Bestellung',
  customers_detail_status_counts: 'Anzahl nach Status',
  customers_detail_orders_section: 'Bestellungen',
  customers_detail_no_orders: 'Noch keine Bestellungen für diesen Kunden.',
  sidebar_account_deletion_retention: 'Kontolöschung & Bindung',
  customers_detail_account_lifecycle: 'Kontolöschung & Bindung',
  customers_detail_account_lifecycle_hint:
    'Speicherung dieser E-Mail, Lösch-Archive (inkl. Umfrage) und kürzliche Lösch-Versuche für dieses Konto.',
  customers_detail_retained_email_title: 'Gespeicherte E-Mail',
  customers_detail_delete_count: 'Vorherige Kontolöschungen (diese E-Mail)',
  customers_detail_first_seen: 'Erstmals gespeichert',
  customers_detail_last_deleted: 'Zuletzt gelöscht am',
  customers_detail_archives: 'Lösch-Archive',
  customers_detail_archive_deleted_at: 'Gelöscht',
  customers_detail_exit_survey: 'Abschlussumfrage',
  customers_detail_exit_reasons: 'Ausgewählte Gründe',
  customers_detail_exit_comment: 'Kommentar',
  customers_detail_recent_attempts: 'Letzte Löschversuche',
  customers_detail_attempt_kind: 'Art',
  customers_detail_attempt_at: 'Zeitpunkt',
  account_deletion_retention_title: 'Kontolöschung & Bindung',
  account_deletion_retention_blurb:
    'Konfigurieren Sie das Bleiben-Angebot bei Kontolöschung, Limits gegen Missbrauch und Optionen der Abschlussumfrage, wenn das Angebotslimit erreicht ist.',
  account_deletion_retention_load_error:
    'Einstellungen zur Kontolöschung konnten nicht geladen werden.',
  account_deletion_retention_saved: 'Einstellungen zur Kontolöschung gespeichert.',
  account_deletion_retention_save_error: 'Einstellungen konnten nicht gespeichert werden.',
  account_deletion_retention_enabled: 'Bindungsflow aktivieren',
  account_deletion_retention_window_days: 'Rollierendes Fenster (Tage)',
  account_deletion_retention_window_days_hint:
    'Vorschauen in diesem Fenster zählen für das Angebotslimit.',
  account_deletion_retention_max_offers: 'Max. Bindungsangebote pro Fenster',
  account_deletion_retention_max_offers_hint:
    'Nach so vielen Vorschauen im Fenster wird das Angebot ausgeblendet und die Umfrage ist Pflicht.',
  account_deletion_retention_offer_title: 'Angebotstitel',
  account_deletion_retention_offer_body: 'Angebotstext',
  account_deletion_retention_promo_code: 'Optionaler Promo-Code',
  account_deletion_retention_promo_hint:
    'Wird dem Kunden angezeigt; für automatische Anwendung muss der Code in Aktionen existieren.',
  account_deletion_retention_exit_reasons: 'Gründe der Abschlussumfrage',
  account_deletion_retention_add_reason: 'Grund hinzufügen',
  account_deletion_retention_exit_reasons_hint:
    'Wenn das Angebotslimit überschritten ist, muss der Kunde Gründe wählen, bevor er löscht.',
  account_deletion_retention_label: 'Bezeichnung',
  account_deletion_retention_discount_percent: 'Einmaliger Bleib-Rabatt (% der Zwischensumme)',
  account_deletion_retention_discount_percent_hint:
    'Wird einmal auf die nächste Bestellung angewendet, nachdem der Kunde das Angebot annimmt (in der Bestellung für Finanzen gespeichert).',
  account_deletion_retention_email_cooldown_days: 'E-Mail-Sperre für Angebot (Tage)',
  account_deletion_retention_email_cooldown_days_hint:
    'Nach Annahme des Bleib-Angebots oder Nutzung des einmaligen Rabatts ist das Angebot für diese E-Mail so lange gesperrt (auch nach Kontolöschung und erneuter Registrierung). 0 zum Deaktivieren.',
  orders_discount_retention: 'Kontobindung (Bleib-Angebot)',
  customers_detail_col_id: 'ID',
  customers_detail_col_date: 'Datum',
  customers_detail_col_total: 'Summe',
  customers_detail_col_city: 'Stadt',
  customers_detail_items_count: '{{count}} Positionen',
  employees_action_enable: 'Aktivieren',
  employees_action_disable: 'Deaktivieren',
  employees_status_error: 'Mitarbeiterstatus konnte nicht aktualisiert werden.',
  employees_table_col_roles: 'Rollen',
  employees_roles_manage: 'Rollen verwalten',
  employees_roles_modal_title: 'Rollen zuweisen',
  employees_roles_load_error: 'Rollen konnten nicht geladen werden.',
  employees_roles_save_error: 'Rollen konnten nicht aktualisiert werden.',

  roles_title: 'Rollen & Berechtigungen',
  roles_subtitle: 'Erstellen Sie Rollen und weisen Sie feingranulare Berechtigungen pro Bereich zu.',
  roles_list_title: 'Rollen',
  roles_new: 'Neue Rolle',
  roles_field_name: 'Rollenname',
  roles_name_placeholder: 'z. B. BUCHHALTUNG',
  roles_field_description: 'Beschreibung',
  roles_description_placeholder: 'Kurze Beschreibung',
  roles_create: 'Rolle erstellen',
  roles_manage: 'Verwalten',
  roles_badge_system: 'System',
  roles_col_name: 'Name',
  roles_col_description: 'Beschreibung',
  roles_col_permissions: 'Berechtigungen',
  roles_col_users: 'Benutzer',
  roles_empty: 'Noch keine Rollen.',
  roles_load_error: 'Rollen konnten nicht geladen werden.',
  roles_create_error: 'Rolle konnte nicht erstellt werden.',
  roles_manage_title: 'Rolle verwalten',
  roles_group_help: 'Wählen Sie aus, was diese Rolle in diesem Bereich darf.',
  roles_group_select_all: 'Alle auswählen',
  roles_group_clear: 'Leeren',
  roles_group_all: 'Alle',
  roles_group_some: 'Teilweise',
  roles_group_none: 'Keine',
  roles_perm_catalog_error: 'Berechtigungskatalog konnte nicht geladen werden.',
  roles_perm_load_error: 'Rollenberechtigungen konnten nicht geladen werden.',
  roles_perm_save_error: 'Berechtigungen konnten nicht gespeichert werden.',
  roles_perm_save_success: 'Berechtigungen gespeichert.',
  // Katalog / Produkte
  products_title: 'Produkte & Katalog',
  products_subtitle:
    'Verwalten Sie die Produkte, Preise und Bilder, die Ihren Shop antreiben.',
  products_search_placeholder: 'Nach Name oder SKU suchen',
  products_search_button: 'Suchen',
  products_search_clear: 'Zurücksetzen',
  products_add_button: 'Produkt hinzufügen',
  products_hide_form: 'Formular ausblenden',
  products_name_label: 'Name',
  products_description_label: 'Beschreibung',
  products_image_label: 'Bild‑URL',
  products_unit_label: 'Basiseinheit',
  products_unit_lb: 'Pfund (lb)',
  products_unit_kg: 'Kilogramm (kg)',
  products_price_label: 'Preis pro Einheit',
  products_delivery_fee_label: 'Fester Lieferzuschlag (optional)',
  products_saving: 'Wird gespeichert…',
  products_update_button: 'Produkt aktualisieren',
  products_create_button: 'Produkt erstellen',
  products_table_title: 'Produktkatalog',
  products_loading: 'Produkte werden geladen…',
  products_empty:
    'Noch keine Produkte vorhanden. Erstellen Sie oben Ihr erstes Produkt.',
  products_table_col_name: 'Name',
  products_table_col_sku: 'SKU',
  products_table_col_category: 'Kategorie',
  products_table_col_price: 'Preis / Einheit',
  products_table_col_sale_price: 'Angebotspreis',
  products_table_col_stock: 'Bestand (lb)',
  products_prev_page: 'Zurück',
  products_next_page: 'Weiter',
  products_action_edit: 'Bearbeiten',
  // Inventar & Einkäufe
  inventory_title: 'Inventar & Bestandskontrolle',
  inventory_subtitle:
    'Verfolgen Sie Bestandslose, Verfallsdaten und Einkaufshistorie mit schneller Suche und Filtern.',
  inventory_tab_lots: 'Bestandslose',
  inventory_tab_purchases: 'Einkaufshistorie',
  inventory_search_button: 'Suchen',
  inventory_lots_search: 'Nach Produktname suchen',
  inventory_lots_loading: 'Bestandslose werden geladen…',
  inventory_lots_empty: 'Keine Bestandslose gefunden.',
  inventory_lots_col_product: 'Produkt',
  inventory_lots_col_batch: 'Charge',
  inventory_lots_col_purchased: 'Gekauft (lb)',
  inventory_lots_col_remaining: 'Verfügbar (lb)',
  inventory_lots_col_expiry: 'Ablaufdatum',
  inventory_prev_page: 'Zurück',
  inventory_next_page: 'Weiter',
  inventory_purchases_search: 'Nach Lieferant oder Referenz suchen',
  inventory_purchases_from: 'Von',
  inventory_purchases_to: 'Bis',
  inventory_purchases_loading: 'Einkäufe werden geladen…',
  inventory_purchases_empty:
    'Für die gewählten Filter wurden keine Einkäufe gefunden.',
  inventory_purchases_col_date: 'Datum',
  inventory_purchases_col_supplier: 'Lieferant',
  inventory_purchases_col_ref: 'Referenz',
  inventory_purchases_col_items: 'Positionen',
  inventory_purchases_col_total: 'Gesamt',

  // Budget
  budget_title: 'Budget',
  budget_subtitle: 'Legen Sie Budgetzeiträume fest. Einkäufe, Verluste und sonstige Ausgaben werden automatisch abgezogen.',
  budget_periods: 'Budgetzeiträume',
  budget_new: 'Neuer Zeitraum',
  budget_name: 'Bezeichnung des Zeitraums',
  budget_initial: 'Anfangsbetrag',
  budget_create: 'Erstellen',
  budget_loading: 'Laden…',
  budget_empty: 'Noch keine Budgetzeiträume.',
  budget_overbudget: 'Überzogen',
  budget_hide_detail: 'Detail ausblenden',
  budget_view_detail: 'Detail anzeigen',
  budget_activate: 'Aktivieren',
  budget_close: 'Schließen',
  budget_balance: 'Saldo',
  budget_adjustment: 'Anpassung (+/-)',
  budget_description: 'Beschreibung',
  budget_add_adjustment: 'Anpassung hinzufügen',
  budget_expense_amount: 'Ausgabebetrag',
  budget_expense_desc: 'z. B. Server, Werbung',
  budget_add_expense: 'Ausgabe hinzufügen',
  budget_type: 'Typ',
  budget_amount: 'Betrag',
  budget_date: 'Datum',
  budget_entry_type_initial: 'Anfang',
  budget_entry_type_adjustment: 'Anpassung',
  budget_entry_type_purchase: 'Einkauf',
  budget_entry_type_loss: 'Verlust',
  budget_entry_type_expense_other: 'Sonstige Ausgabe',

  // Losses
  losses_title: 'Verluste erfassen',
  losses_subtitle: 'Erfassen Sie Produktverluste (abgelaufen, beschädigt, verloren). Wird von Bestand und aktivem Budget abgezogen.',
  losses_history: 'Verlusthistorie',
  losses_record: 'Verlust erfassen',
  losses_product: 'Produkt',
  losses_search_product: 'Produkt suchen',
  losses_lot: 'Charge (optional)',
  losses_quantity: 'Menge (lb)',
  losses_reason: 'Grund',
  losses_notes: 'Notizen',
  losses_submit: 'Verlust erfassen',
  losses_col_date: 'Datum',
  losses_col_product: 'Produkt',
  losses_col_lot: 'Charge',
  losses_col_qty: 'Menge (lb)',
  losses_col_value: 'Wert',
  losses_col_reason: 'Grund',
  losses_col_notes: 'Notizen',
  losses_empty: 'Noch keine Verluste erfasst.',
  losses_total_value: 'Gesamtwert der Verluste',
  losses_filtered: 'gefiltert',
  losses_filter_by_reason: 'Nach Grund filtern',
  losses_all_reasons: 'Alle Gründe',
  losses_from_date: 'Von Datum',
  losses_to_date: 'Bis Datum',
  losses_clear_filters: 'Filter löschen',
  loss_reason_expired: 'Abgelaufen',
  loss_reason_damaged: 'Beschädigt',
  loss_reason_lost: 'Verloren',
  loss_reason_theft: 'Diebstahl',
  loss_reason_other: 'Sonstiges',

  sidebar_payments: 'Zahlungen',
  sidebar_promotions: 'Aktionen',
  sidebar_referrals: 'Empfehlungen',
  referrals_stat_pending: 'Ausstehend',
  referrals_stat_qualified: 'Qualifiziert',
  referrals_stat_rejected: 'Abgelehnt',
  referrals_stat_codes: 'Codes vergeben',
  referrals_stat_signup_sessions: 'Registrierungen',
  referrals_stat_checkout_queue: 'Checkout-Warteschl.',
  referrals_deactivated_wind_down:
    'Programm aus für neue Links und Registrierungen ohne gespeicherte Session. Laufend: {{pending}} ausstehende Empfehlung(en), {{intents}} Registrierungs-Session(s) (48 h), {{checkout}} unbezahlte Bestellung(en) mit Empfehlungsrabatt.',
  referrals_wind_down_explainer:
    'Neue öffentliche Links sind deaktiviert. Kunden mit bereits geöffneter Registrierung (48 h) können abschließen. Geworbene mit offener Erstbestellung behalten den Willkommensrabatt bis zur Zahlung oder Stornierung.',
  payments_title: 'Zahlungen',
  payments_subtitle:
    'Stripe-Kartenzahlungen: Kunde, Bestellung, Betrag, Status und sichere Metadaten (Marke, letzte 4). Keine vollständige Kartennummer.',
  payments_load_error: 'Zahlungen konnten nicht geladen werden.',
  payments_filter_search: 'Suche',
  payments_filter_search_ph: 'Bestellung, Intent, E-Mail, last4…',
  payments_filter_status: 'Stripe-Status',
  payments_filter_from: 'Von',
  payments_filter_to: 'Bis',
  payments_apply: 'Anwenden',
  payments_col_date: 'Datum',
  payments_col_customer: 'Kunde',
  payments_customer_deleted_badge: 'Konto gelöscht',
  payments_customer_deleted_hint:
    'Zahlungshistorie bleibt erhalten. Das Kundenprofil wurde bei Löschung entfernt; E-Mail kann aus Stripe-Quittung oder Bestell-Snapshot stammen.',
  payments_col_order: 'Bestellung',
  payments_col_order_id: 'Bestell-ID',
  payments_col_payment_id: 'Zahlungs-ID',
  payments_expand_order_id: 'Bestell-ID',
  payments_expand_payment_id: 'Zahlungs-ID',
  payments_col_amount: 'Betrag',
  payments_col_amount_tooltip:
    'Betrag dieser Zahlung in USD (Backoffice-Basis). Bei Vorbestellungen: Spalte „Bestellung (USD)“ für Gesamtsumme, Anzahlung und Restbetrag.',
  payments_col_order_balance: 'Bestellung (USD)',
  payments_order_total_short: 'Gesamt',
  payments_order_deposit_short: 'Anzahlung',
  payments_order_remaining_short: 'Rest',
  payments_col_status: 'Status',
  payments_col_card: 'Karte',
  payments_col_type: 'Typ',
  payments_empty: 'Keine Zahlungen gefunden.',
  payments_view: 'Details',
  payments_pci_note:
    'Sensible Kartendaten tokenisiert Stripe. Hier nur sichere Anzeigefelder nach Zahlung.',
  payments_detail_title: 'Zahlungsdatensatz',
  payments_detail_error: 'Zahlungsdetails konnten nicht geladen werden.',

  sidebar_group_security: 'Sicherheit',
  sidebar_activities: 'Aktivitätsprotokoll',
  activities_title: 'Aktivitätsprotokoll',
  activities_subtitle:
    'Protokoll für Anmeldungen, Sicherheitsereignisse und interne Aktionen. Filtern Sie nach Zeit, IP, Benutzer-IDs, Schweregrad und Freitext.',
  activities_load_error: 'Aktivitätsprotokoll konnte nicht geladen werden.',
  activities_apply: 'Filter anwenden',
  activities_clear: 'Filter zurücksetzen',
  activities_filter_q: 'Suche Nachricht / Kategorie / Aktion',
  activities_filter_q_ph: 'z. B. login, brute',
  activities_filter_category: 'Kategorie (exakt)',
  activities_filter_action: 'Aktion (enthält)',
  activities_filter_action_ph: 'z. B. login.success',
  activities_filter_severity: 'Schweregrad',
  activities_filter_from: 'Von Datum',
  activities_filter_to: 'Bis Datum',
  activities_filter_actor: 'Akteur Benutzer-ID',
  activities_filter_target: 'Ziel Benutzer-ID',
  activities_filter_ip: 'IP (exakt)',
  activities_filter_ip_contains: 'IP (enthält)',
  activities_filter_subject_type: 'Subjekttyp',
  activities_filter_subject_id: 'Subjekt-ID',
  activities_page_size: 'Zeilen pro Seite',
  activities_col_time: 'Zeit',
  activities_col_severity: 'Schweregrad',
  activities_col_category: 'Kategorie',
  activities_col_action: 'Aktion',
  activities_col_actor: 'Akteur',
  activities_col_ip: 'IP',
  activities_col_message: 'Nachricht',
  activities_empty: 'Keine Einträge für diese Filter.',
  activities_pagination_info: 'Seite {{page}} von {{totalPages}} · {{total}} Ereignisse',
  activities_detail_ids: 'Kennungen',
  activities_detail_request: 'Anfrage',
  activities_detail_metadata: 'Metadaten (JSON)',

  promotions_title: 'Aktionen & Codes',
  promotions_subtitle:
    'Rabattcodes für die Kasse anlegen. Optional auf ein Kundenkonto, Mindest-Umsatz oder Warenkorb begrenzen.',
  promotions_load_error: 'Aktionen konnten nicht geladen werden.',
  promotions_empty: 'Noch keine Aktionen.',
  promotions_col_code: 'Code',
  promotions_col_type: 'Typ',
  promotions_col_value: 'Wert',
  promotions_col_restricted: 'Nur Konto',
  promotions_col_expires: 'Endet',
  promotions_col_active: 'Aktiv',
  promotions_col_actions: 'Aktionen',
  promotions_type_percent: 'Prozent',
  promotions_type_fixed: 'Festbetrag USD',
  promotions_unlimited: '—',
  promotions_deactivate: 'Deaktivieren',
  promotions_create_open: 'Neue Aktion',
  promotions_form_code: 'Code',
  promotions_form_description: 'Beschreibung (intern)',
  promotions_form_discount_type: 'Rabattart',
  promotions_form_percent: 'Prozent (0–100)',
  promotions_form_fixed: 'Festbetrag (USD)',
  promotions_form_restricted_customer: 'Auf Kunden-E-Mail beschränken (optional)',
  promotions_form_restricted_ph: 'kunde@beispiel.de',
  promotions_form_restricted_hint:
    'Wenn gesetzt, kann nur das Konto mit dieser E-Mail den Code einlösen.',
  promo_seg_collapsed_sub:
    'Ausklappen, um Filter zu setzen und zu suchen. Codes können auch ohne Suche per Kunden-E-Mail eingeschränkt werden.',
  promo_seg_table_idle: 'Filter oben ausklappen und „Suche ausführen“ klicken, um Kunden zu laden.',
  promotions_form_min_lifetime: 'Mindest-Lebenszeitumsatz USD (optional)',
  promotions_form_min_subtotal: 'Mindest-Warenkorb USD (optional)',
  promotions_form_max_total: 'Max. Einlösungen gesamt (optional)',
  promotions_form_max_per_customer: 'Max. pro Kunde (optional)',
  promotions_form_expires: 'Läuft ab (optional, lokal)',
  promotions_form_active: 'Aktiv',
  promotions_save: 'Aktion anlegen',
  promotions_save_error: 'Speichern fehlgeschlagen.',
  promotions_deactivate_error: 'Deaktivieren fehlgeschlagen.',

  delivery_batches_title: 'Liefer-Chargen',
  delivery_batches_subtitle:
    'Bezahlte Bestellungen nach Gebiet und Zeitfenster gruppieren. Zuweisungen ändern, bis versendet wird.',
  delivery_batches_load_error: 'Liefer-Chargen konnten nicht geladen werden.',
  delivery_batches_save_error: 'Charge konnte nicht gespeichert werden.',
  delivery_batches_create: 'Neue Charge',
  delivery_batches_area_label: 'Gebiet',
  delivery_batches_area_ph: 'z. B. New York Batch',
  delivery_batches_name_optional: 'Interner Name (optional)',
  delivery_batches_country_optional: 'Land einschränken (optional)',
  delivery_batches_city_optional: 'Stadt einschränken (optional)',
  delivery_batches_window_start: 'Fenster Start',
  delivery_batches_window_end: 'Fenster Ende',
  delivery_batches_estimated_window: 'Voraussichtliches Lieferfenster',
  delivery_batches_notes_optional: 'Notizen (optional)',
  delivery_batches_save: 'Charge anlegen',
  delivery_batches_list: 'Chargen',
  delivery_batches_empty: 'Noch keine Chargen.',
  delivery_batches_select: 'Charge wählen für Details und Zuweisungen.',
  delivery_batches_detail_error: 'Charge konnte nicht geladen werden.',
  delivery_batches_close: 'Als geschlossen markieren',
  delivery_batches_close_dispatch: 'Charge schließen & Bestellungen versenden',
  delivery_batches_close_confirm:
    'Charge schließen? Alle bezahlten Bestellungen werden in einem Hintergrundjob versendet (nicht in dieser Anfrage). Sie können gehen und jederzeit zurückkehren, um den Fortschritt zu sehen.',
  delivery_batches_dispatching:
    'Hintergrundjob läuft… Bestellungen werden als VERSENDET markiert. Die Charge schließt danach automatisch.',
  delivery_batches_dispatch_progress: '{{processed}} / {{total}} Bestellungen bearbeitet',
  delivery_batches_dispatch_background:
    'Sie können diese Seite verlassen — der Fortschritt wird gespeichert. Öffnen Sie die Charge wieder, um den aktuellen Stand zu sehen.',
  delivery_batches_dispatch_failed: 'Dispatch fehlgeschlagen. Details unten.',
  delivery_batches_dispatch_partial_title: 'Einige Bestellungen konnten nicht versendet werden:',
  delivery_batches_dispatch_notice:
    'Schließen-Job in Warteschlange. Bezahlte Bestellungen werden im Hintergrund als VERSENDET markiert.',
  delivery_batches_delete: 'Leere Charge löschen',
  delivery_batches_delete_confirm: 'Diese Charge löschen? Nur ohne Bestellungen.',
  delivery_batches_orders_count: '{{count}} Bestellungen',
  delivery_batches_add_order: 'Bezahlte Bestellung zuweisen',
  delivery_batches_pick_order: 'Bestellung wählen…',
  delivery_batches_assign: 'Zuweisen',
  delivery_batches_in_batch: 'Bestellungen in dieser Charge',
  delivery_batches_no_orders: 'Noch keine Bestellungen in dieser Charge.',
  delivery_batches_speed: 'Liefergeschwindigkeit',
  delivery_batches_remove: 'Aus Charge entfernen',
  delivery_batches_create_expand: 'Formular anzeigen',
  delivery_batches_create_collapse: 'Formular ausblenden',
  delivery_batches_search_hint:
    'Land und/oder Ort eingeben (Vorschläge aus bezahlten Bestellungen) oder Stichwörter — Treffer aktualisieren sich live.',
  delivery_batches_searching: 'Suche…',
  delivery_batches_assign_country: 'Land',
  delivery_batches_assign_country_ph: 'z. B. USA',
  delivery_batches_assign_town: 'Ort / Stadt',
  delivery_batches_assign_town_ph: 'z. B. New York',
  delivery_batches_order_search: 'Stichwörter (optional)',
  delivery_batches_order_search_ph: 'Bestell-ID, Kundenname, E-Mail…',
  delivery_batches_search_required: 'Mindestens Land, Ort oder Stichwort eingeben, dann Suchen.',
  delivery_batches_search_button: 'Suchen',
  delivery_batches_search_empty_prompt:
    'Tippen Sie Land, Ort oder Stichwort — bezahlte Bestellungen werden live gesucht.',
  delivery_batches_select_all_results: 'Alle in den Ergebnissen wählen',
  delivery_batches_select_all_area: 'Alle in diesem Gebiet wählen',
  delivery_batches_clear_selection: 'Auswahl leeren',
  delivery_batches_area_unknown: 'Adresse unvollständig',
  delivery_batches_suggest_hint:
    'Zeilen anklicken zum Auswählen. Bestellungen in dieser Charge sind ausgeblendet.',
  delivery_batches_selected_n: '{{count}} ausgewählt',
  delivery_batches_assign_selected: 'Ausgewählte zuweisen',
  delivery_batches_other_batch: 'In: {{batch}}',
  delivery_batches_no_search_matches: 'Keine passenden Bestellungen.',
  sidebar_delivery_batches: 'Liefer-Chargen',
  orders_delivery_speed: 'Lieferung',
  orders_batch_label: 'Charge',
  orders_no_batch: 'Noch keiner Charge zugewiesen',
  orders_receipt_download: 'Quittung (PDF)',
  orders_receipt_error: 'Quittung konnte nicht heruntergeladen werden.',
  orders_progress_title: 'Bestellfortschritt',
  orders_progress_simple_subtitle: 'Standard-Erfüllung',
  orders_progress_incident_badge: 'Vorfall & Rückerstattung',
  orders_progress_main: 'Erfüllung',
  orders_progress_refund_step: 'Rückerstattung',
  orders_progress_branch: 'Lieferproblem & erneuter Versand',
  orders_progress_issue: 'Problem',
  orders_progress_investigating: 'Prüfung',
  orders_progress_resolution: 'Schlichtung',
  orders_progress_reship_prep: 'Nachsendung wartet',
  orders_progress_out_again: 'Unterwegs (Nachsendung)',
  orders_progress_merge_delivered: 'Dann Zustellung abschließen',
  orders_progress_unreachable_short: 'Unzustellbar',
  orders_progress_damaged_short: 'Beschädigt',
  orders_progress_fault_employee: 'Team',
  orders_progress_fault_customer: 'Kunde',
  orders_progress_refund_sidebar:
    'Rückzahlung oder Rücksendung läuft — Ablauf weicht ggf. vom Standard ab.',
  orders_progress_delivered_skipped: 'k. A.',
  incident_open_unreachable_confirm_title: 'Unzustellbarkeit bestätigen',
  incident_open_unreachable_confirm_message:
    'Diese Bestellung wirklich als unzustellbar markieren?',
  incident_open_unreachable_confirm_message_batched:
    'Diese Bestellung ist der Charge „{{batch}}“ zugeordnet. Sie wird aus der Charge entfernt, damit diese unzustellbare Lieferung außerhalb der Chargen-Tour bearbeitet werden kann. Fortfahren?',
  incident_open_damaged_confirm_title: 'Beschädigung bestätigen',
  incident_open_damaged_confirm_message:
    'Diese Bestellung wirklich als beschädigt markieren?',
  incident_open_damaged_confirm_message_batched:
    'Diese Bestellung ist der Charge „{{batch}}“ zugeordnet. Sie wird aus der Charge entfernt, damit diese beschädigte Sendung außerhalb der Chargen-Tour bearbeitet werden kann. Fortfahren?',

  sidebar_delivery_pricing: 'Lieferpreise',
  delivery_pricing_title: 'Lieferpreise',
  delivery_pricing_subtitle:
    'Gewichts- oder fahrzeitbasierte Gebühren wählen und Standard- vs. Express-Stufen konfigurieren. Der Ursprung für die Fahrzeit entspricht den Koordinaten aus „Öffentlicher Kontakt“ (gespeichert bei Adressauswahl). Fahrzeiten werden im Hintergrund berechnet, wenn Kunden ihre Adresse speichern.',
  delivery_pricing_load_error: 'Lieferpreise konnten nicht geladen werden.',
  delivery_pricing_save_error: 'Speichern fehlgeschlagen.',
  delivery_pricing_saved: 'Lieferpreise gespeichert.',
  delivery_pricing_store_section: 'Standort (für Fahrzeit)',
  delivery_pricing_store_public_contact_info:
    'Es werden dieselben Koordinaten wie der öffentliche Kontakt verwendet. Adresse dort per Vorschlag wählen, damit Breite/Länge gespeichert werden — hier nicht erneut eingeben.',
  delivery_pricing_store_edit_public_contact: 'Öffentlichen Kontakt bearbeiten',
  delivery_pricing_store_resolved: 'Verwendeter Ursprung',
  delivery_pricing_store_source_public: 'Aus öffentlichem Kontakt',
  delivery_pricing_store_source_override: 'Manuelle Überschreibung',
  delivery_pricing_store_source_none: 'Noch keine Koordinaten',
  delivery_pricing_store_no_coords_hint:
    'Öffentlichen Kontakt öffnen, Land und Stadt wählen, dann Straße aus den Vorschlägen wählen, damit Breite und Länge gespeichert werden.',
  delivery_pricing_store_override_section: 'Optional: manuelle Koordinaten',
  delivery_pricing_store_override_hint:
    'Nur wenn nötig (z. B. anderes Depot). Leer lassen, um den öffentlichen Kontakt zu verwenden.',
  delivery_pricing_store_clear_override: 'Öffentlichen Kontakt verwenden',
  delivery_pricing_clear_override_confirm:
    'Manuelle Überschreibung entfernen und Koordinaten aus dem öffentlichen Kontakt verwenden?',
  delivery_pricing_store_set_override: 'Überschreibung speichern',
  delivery_pricing_latitude: 'Breitengrad',
  delivery_pricing_longitude: 'Längengrad',
  delivery_pricing_label: 'Bezeichnung (optional)',
  delivery_pricing_mode_label: 'Preismodell',
  delivery_pricing_mode_weight: 'Gewichtsbasiert (Legacy)',
  delivery_pricing_mode_driving: 'Fahrzeit (Lager → Kunde)',
  delivery_pricing_weight_section: 'Gewichtspreise (Fallback)',
  delivery_pricing_weight_base: 'Grundgebühr (USD)',
  delivery_pricing_weight_per_lb: 'Pro lb (USD)',
  delivery_pricing_express_surcharge: 'Express-Zuschlag (USD)',
  delivery_pricing_weight_days_standard: 'Standard-Liefertage (Gewicht)',
  delivery_pricing_weight_days_express: 'Express-Liefertage (Gewicht)',
  delivery_pricing_driving_section: 'Fahrzeit-Stufen',
  delivery_pricing_standard_days: 'Standard-VET (Tage)',
  delivery_pricing_express_days: 'Express-VET (Tage)',
  delivery_pricing_tiers_hint:
    'Je Zeile: max. Fahrzeit in Minuten (inkl.) und Gebühr in USD. Zeilen nach aufsteigenden Minuten sortieren; für die letzte Stufe sehr hohes max. verwenden.',
  delivery_pricing_standard_tiers: 'Standard-Stufen (JSON-Array)',
  delivery_pricing_express_tiers: 'Express-Stufen (JSON-Array)',
  delivery_pricing_recompute_all: 'Neuberechnung für alle Kunden einreihen',
  delivery_pricing_recompute_all_confirm:
    'Fahrzeit-Jobs für alle Kunden einreihen? Das kann dauern.',
  delivery_pricing_recompute_all_done: '{{count}} Jobs eingerichtet.',
  delivery_pricing_redis_hint:
    'Benötigt Redis (BullMQ) und GOOGLE_MAPS_API_KEY mit aktivierter Routes API in Google Cloud (nicht die alte Distance Matrix).',
  delivery_pricing_readonly:
    'Nur Ansicht. Zum Bearbeiten DELIVERY_PRICING:UPDATE (oder Admin) erforderlich.',

  delivery_pricing_rules_section: 'Preisregeln (Zwischensumme + Gewicht + Entfernung + Land)',
  delivery_pricing_express_enabled: 'Expresslieferung aktivieren',
  delivery_pricing_store_country: 'Shop-Land (ISO-Code)',
  delivery_pricing_days_standard: 'Standard-ETA (Tage)',
  delivery_pricing_days_express: 'Express-ETA (Tage)',
  delivery_pricing_countries_section: 'Zielländer',
  delivery_pricing_add_country: 'Land hinzufügen',
  delivery_pricing_country_code: 'Ländercode',
  delivery_pricing_country_express_enabled: 'Express für dieses Land aktiviert',
  delivery_pricing_border_fee: 'Grenzgebühr (USD)',
  delivery_pricing_base_fee: 'Grundgebühr (USD)',
  delivery_pricing_per_mile: 'Pro Meile (USD)',
  delivery_pricing_per_lb: 'Pro lb (USD)',
  delivery_pricing_us_threshold_section: 'USA-Schwelle (gratis / Pauschale)',
  delivery_pricing_free_min_subtotal: 'Min. Zwischensumme (USD)',
  delivery_pricing_free_max_weight: 'Max. Gewicht (lb)',
  delivery_pricing_free_fee: 'Gebühr bei Qualifikation (USD)',
  delivery_pricing_preview_title: 'Vorschau-Rechner',
  delivery_pricing_preview_hint: 'Zahlen testen, bevor du speicherst.',
  delivery_pricing_preview_subtotal: 'Zwischensumme (USD)',
  delivery_pricing_preview_weight: 'Gesamtgewicht (lb)',
  delivery_pricing_preview_miles: 'Entfernung (Meilen)',
  delivery_pricing_preview_country: 'Zielland',
  delivery_pricing_preview_standard_fee: 'Standardgebühr',
  delivery_pricing_preview_express_fee: 'Expressgebühr',
  delivery_pricing_preview_express_unavailable: 'Express nicht verfügbar (global oder für dieses Land deaktiviert).',
  delivery_pricing_preview_threshold_applied: 'Schwelle angewendet.',
  delivery_pricing_preview_invalid_country: 'Bitte Ländercode eingeben (z. B. US).',
  delivery_pricing_preview_country_missing: 'Keine Regel für {{country}} konfiguriert.',

  orders_col_order_id: 'Bestell-ID',
  orders_col_total: 'Gesamt',
  orders_preorder_card_payments_heading: 'Kartenzahlungen (Datensätze)',
  orders_preorder_deposit_payment: 'Anzahlung (erste Belastung)',
  orders_preorder_balance_payment: 'Restbetrag (nach Freigabe)',
  orders_preorder_balance_payments_heading: 'Restzahlungen (nach Freigabe)',
  orders_preorder_balance_payment_index: 'Belastung {{n}}',
  orders_preorder_balance_payment_pending:
    'Noch keine Restzahlung. Der Kunde zahlt den Rest nach Freigabe der Vorbestellung.',
  orders_customer_account_deleted_banner:
    'Kundenkonto gelöscht — Bestellung für den Betrieb archiviert. Status, Batch-Zuweisung, Vorfälle und Nachsendung sind gesperrt. Stripe-Prüfung unten bleibt für ausstehende Checkout-Zahlungen möglich.',
  orders_customer_account_deleted_badge: 'Konto gelöscht',
  orders_workflow_frozen_short: 'Archiviert (kein Workflow)',
  orders_view_scope: 'Bestellansicht',
  orders_filters_label: 'Suche & Filter',

  mail_routing_title: 'E-Mail-Absender',
  mail_routing_subtitle:
    'From- und Reply-To-Adressen pro E-Mail-Typ wählen. Verifizierte Identitäten in Amazon SES verwenden. Die erste From-Adresse gilt pro Typ; optional no-reply als Reply-To.',
  mail_routing_load_error: 'Einstellungen konnten nicht geladen werden.',
  mail_routing_save_error: 'Speichern fehlgeschlagen.',
  mail_routing_saved: 'Absender gespeichert.',
  mail_routing_hint:
    'Leer lassen für SES_SOURCE_EMAIL und MAIL_DEFAULT_REPLY_TO vom Server. Mehrere From-Adressen möglich; nur die erste wird als Absender genutzt.',
  mail_routing_readonly:
    'Nur Ansicht: Änderungen nur mit Berechtigung „E-Mail-Absender konfigurieren“ (MAIL_ROUTING:UPDATE).',
  mail_routing_from: 'From-Adressen (eine pro Zeile)',
  mail_routing_from_help:
    'Müssen in AWS SES verifiziert sein. Die erste Adresse ist der Absender.',
  mail_routing_reply_to: 'Reply-To (no-reply empfohlen)',
  mail_routing_bcc: 'BCC (optional, interne Kopien)',
  mail_routing_bcc_help:
    'Blindkopie desselben Nachrichteninhalts (z. B. interne Warnungen).',
  mail_routing_save: 'Absender speichern',
  mail_routing_saving: 'Speichern…',

  mail_routing_purpose_EMAIL_VERIFICATION: 'E-Mail-Verifizierung',
  mail_routing_purpose_PASSWORD_RESET: 'Passwort zurücksetzen',
  mail_routing_purpose_MFA_LOGIN_CODE: 'Anmeldecode (MFA)',
  mail_routing_purpose_EMPLOYEE_INVITE: 'Mitarbeiter-Einladung',
  mail_routing_purpose_WELCOME_CUSTOMER: 'Willkommen (neuer Kunde)',
  mail_routing_purpose_ORDERS_CUSTOMER: 'Bestellungen (Kunde)',
  mail_routing_purpose_ORDERS_STAFF: 'Bestellungen (Team)',
  mail_routing_purpose_BUDGET_REPORT: 'Budget-Berichte',
  mail_routing_purpose_EXPIRY_ALERT: 'Ablauf-Warnungen',
  mail_routing_purpose_GENERAL: 'Sonstiges / Standard',
  mail_routing_purpose_REFERRAL: 'Empfehlungsprogramm (Kunde)',
} as const;

export const deRbac = {
  perm_group: {
    catalog: 'Katalog',
    inventory: 'Inventar',
    orders: 'Bestellungen',
    payments: 'Zahlungen (Stripe)',
    finance: 'Finanzen',
    settings: 'Einstellungen',
    users: 'Benutzer',
    rbac: 'Zugriffssteuerung',
    security: 'Sicherheit & Audit',
  },
  perm_desc: {
    payment: {
      read:
        'Zahlungen-Bereich: Kartenumsätze listen, suchen/filtern, Details (Stripe-Intent, Karte, verknüpfte Bestellung).',
    },
  },
  perm: {
    product: {
      read: 'Produkte lesen',
      create: 'Produkte erstellen',
      update: 'Produkte aktualisieren',
      delete: 'Produkte löschen',
      upload: 'Produktbilder hochladen',
    },
    category: {
      read: 'Kategorien lesen',
      create: 'Kategorien erstellen',
      update: 'Kategorien aktualisieren',
      delete: 'Kategorien löschen',
    },
    supplier: {
      read: 'Lieferanten lesen',
      create: 'Lieferanten erstellen',
      update: 'Lieferanten aktualisieren',
      delete: 'Lieferanten löschen',
    },
    order: {
      read: 'Bestellungen lesen',
      update: 'Bestellungen aktualisieren',
    },
    order_detail: {
      read: 'View order details',
    },
    order_incident: {
      read: 'View order incidents',
      update: 'Manage order incidents',
    },
    order_resolution: {
      read: 'View incident resolutions',
      update: 'Resolve order incidents',
    },
    order_reship: {
      create: 'Reship orders after employee fault',
    },
    order_stats: {
      read: 'View order analytics',
    },
    promotion: {
      read: 'Aktionen ansehen',
      create: 'Aktionen erstellen',
      update: 'Aktionen bearbeiten',
      delete: 'Aktionen deaktivieren',
    },
    referral: {
      read: 'Empfehlungsprogramm ansehen',
      update: 'Empfehlungsprogramm und Ankündigungs-E-Mails konfigurieren',
    },
    payment: {
      read: 'Stripe-Zahlungen-Bereich ansehen',
    },
    mail_routing: {
      read: 'E-Mail-Absender ansehen',
      update: 'E-Mail-Absender konfigurieren',
    },
    purchase: {
      read: 'Einkäufe lesen',
      create: 'Einkäufe erstellen',
      update: 'Einkäufe aktualisieren',
      delete: 'Einkäufe löschen',
    },
    purchase_order: {
      read: 'Bestellungen lesen',
      create: 'Bestellungen erstellen',
      update: 'Bestellungen aktualisieren',
      delete: 'Bestellungen löschen',
      complete: 'Bestellungen abschließen',
      print: 'Bestellungen drucken',
    },
    stock_lot: {
      read: 'Bestandschargen lesen',
      update: 'Bestandschargen aktualisieren',
    },
    loss: {
      read: 'Verluste lesen',
      create: 'Verluste erfassen',
    },
    budget_period: {
      read: 'Budgetzeiträume lesen',
      create: 'Budgetzeiträume erstellen',
      update: 'Budgetzeiträume aktualisieren',
      delete: 'Budgetzeiträume löschen',
    },
    budget_report: {
      create: 'Budgetberichte erstellen',
    },
    currency: {
      read: 'Währungen lesen',
      update: 'Währungen verwalten',
    },
    ui_setting: {
      read: 'Anzeigeeinstellungen ansehen',
      update: 'Anzeigeeinstellungen ändern',
    },
    expiry_alert: {
      read: 'Ablaufwarnungen lesen',
      update: 'Ablaufwarnungen verwalten',
    },
    hero: {
      read: 'Hero-Slides lesen',
      create: 'Hero-Slides erstellen',
      update: 'Hero-Slides aktualisieren',
      delete: 'Hero-Slides löschen',
      upload: 'Hero-Bilder hochladen',
    },
    employee: {
      read: 'Mitarbeiter lesen',
      create: 'Mitarbeiter erstellen',
      update: 'Mitarbeiter aktualisieren',
    },
    customer: {
      read: 'Kunden lesen',
    },
    delivery_pricing: {
      read: 'Lieferpreise ansehen',
      update: 'Lieferpreise und Lagerstandort konfigurieren',
    },
    role: {
      read: 'Rollen lesen',
      create: 'Rollen erstellen',
      update: 'Rollen aktualisieren',
      delete: 'Rollen löschen',
    },
    activity: {
      read: 'Sicherheits-Aktivitätsprotokoll ansehen (Audit, IP-Filter)',
    },
  },
} as const;

export const deCommon = {
  save: 'Speichern',
  cancel: 'Abbrechen',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  saving: 'Speichern…',
  empty_placeholder: '—',
  loading: 'Wird geladen…',
  list_loading_title: 'Daten werden geladen…',
  list_loading_hint:
    'Bei langsamer Verbindung kann das etwas dauern. Vielen Dank für Ihre Geduld.',
  filter: 'Filtern',
  clear: 'Zurücksetzen',
  all: 'Alle',
  prev: 'Zurück',
  next: 'Weiter',
  remove: 'Entfernen',
  collapse: 'Einklappen',
  expand: 'Ausklappen',
  language: 'Sprache',
  currency: 'Währung',
} as const;

export const deEmployee = {
  sidebar_profile: 'Profil',
  sidebar_team: 'Team',
  sidebar_security: 'Sicherheit',
  title: 'Teampofil',
  subtitle:
    'Verwalten Sie die Profildaten Ihres Personals, die im Backoffice verwendet werden.',
  sign_in_required: 'Melden Sie sich an, um Ihr Profil zu sehen.',
  profile_section_title: 'Mitarbeiterprofil',
  profile_section_subtitle:
    'So werden Ihre Daten im Backoffice angezeigt.',
  field_full_name: 'Vollständiger Name',
  field_role_title: 'Rolle / Titel',
  field_phone: 'Telefon',
  edit_button: 'Bearbeiten',
  save_button: 'Änderungen speichern',
  saving_label: 'Speichern…',
  cancel_button: 'Abbrechen',
  readonly_name_label: 'Name',
  readonly_role_label: 'Rolle / Titel',
  readonly_phone_label: 'Telefon',
  not_set: 'Nicht festgelegt',
  load_error: 'Profil konnte nicht geladen werden.',
  save_success: 'Profil erfolgreich aktualisiert.',
  save_error: 'Profil konnte nicht gespeichert werden.',
  account_email_label: 'Konten-E-Mail',
  account_role_label: 'Rolle',
  security_section_title: 'Sicherheit',
  current_password_label: 'Aktuelles Passwort',
  new_password_label: 'Neues Passwort',
  confirm_password_label: 'Neues Passwort bestätigen',
  password_mismatch: 'Die Passwörter stimmen nicht überein.',
  password_save_button: 'Passwort aktualisieren',
  password_saving_label: 'Aktualisierung…',
  password_change_success: 'Passwort erfolgreich aktualisiert.',
  password_change_error: 'Passwort konnte nicht geändert werden.',
  password_open_button: 'Passwort ändern',
} as const;

export const deEmployeeInvite = {
  title: 'Einladung abschließen',
  subtitle:
    'Legen Sie ein Passwort für Ihr Lewouhmart-Mitarbeiterkonto fest. Beim nächsten Anmelden wird ein MFA-Code an Ihre E-Mail gesendet.',
  invalid_link:
    'Dieser Einladungslink ist ungültig. Bitte verwenden Sie den Link aus Ihrer E-Mail.',
  field_password_label: 'Passwort wählen',
  field_password_confirm_label: 'Passwort bestätigen',
  password_mismatch: 'Die Passwörter stimmen nicht überein.',
  suggest_password: 'Sicheres Passwort vorschlagen',
  saving_label: 'Speichern…',
  save_button: 'Passwort speichern',
  back_to_signin: 'Zur Anmeldung',
  error_generic: 'Einladung konnte nicht abgeschlossen werden.',
  success_message:
    'Ihr Passwort wurde festgelegt. Sie können sich jetzt anmelden.',
} as const;


